import { useEffect, useState } from "react";
import { Button } from "@headlessui/react";
import { handleEnterKey } from "../../../app/keyboardUtils";
import AddStudentsForm from "../AddStudentsForm";
import { useAddStudentsToCourseByAdminMutation } from "../coursesApiSlice";

interface Props {
	courseId?: number;
	seatsRemaining: number;
	showSeatsWarning: boolean;
	onClose: () => void;
	onSwitchToNewTab?: () => void;
	setErrorMessage?: (message: string) => void;
}

export default function AddExistingStudentsToCourseForm(props: Props) {
	const [addStudentCheckedIds, setAddStudentCheckedIds] = useState<number[]>([]);
	const [hasStudents, setHasStudents] = useState<boolean>(true);

	const [addStudents] = useAddStudentsToCourseByAdminMutation();

	useEffect(() => {
		if (!hasStudents && props.seatsRemaining > 0 && props.onSwitchToNewTab) {
			props.onSwitchToNewTab();
		}
	}, [hasStudents, props.onSwitchToNewTab]);

	function handleAddStudents() {
		if (props.courseId && addStudentCheckedIds.length > 0) {
			addStudents({ courseId: props.courseId, userIds: addStudentCheckedIds })
				.unwrap()
				.then((errors) => {
					let errorMessage = "";
					if (errors && errors.length > 0) {
						errorMessage = `The following students could not be added to the course: `;
						errors.map((error) => {
							errorMessage += `\n${error}`;
						});
						scrollTo(0, 0);
					}

					if (props.setErrorMessage) props.setErrorMessage(errorMessage);
					props.onClose();
				})
				.catch((error) => {
					console.log(error.data);
				});
		}
	}

	function updateAddStudentCheckedIds(ids: number[]) {
		setAddStudentCheckedIds(ids);
	}

	function handleCancel() {
		props.onClose();
	}

	return (
		<section>
			<AddStudentsForm
				seatsRemaning={props.seatsRemaining}
				limitedSeatsRemaining={props.showSeatsWarning}
				courseId={props.courseId}
				updateCheckedIdsCallback={updateAddStudentCheckedIds}
				hasStudentsCallback={setHasStudents}
			/>
			<div className="mt-2 grid grid-cols-2 gap-3">
				<Button
					id="cancel-button"
					onClick={handleCancel}
					onKeyDown={(e) => handleEnterKey(e, handleCancel)}
					className="btn btn-neutral">
					Cancel
				</Button>
				<Button
					id="confirm-button"
					disabled={addStudentCheckedIds.length < 1}
					onClick={handleAddStudents}
					onKeyDown={(e) => handleEnterKey(e, handleAddStudents)}
					className="btn btn-primary">
					Add Students
				</Button>
			</div>
		</section>
	);
}
